import {LibEnvironment} from './LibEnvironment';

export class EnvironmentService {
    public constructor(public environment: LibEnvironment) {
    }
}
